<template>
  <div id="app" class="app">
    <div class="content">
      <router-view v-if="isShow" />
    </div>
    <videoCall-model ref="videoCallModel" @toTimer="toTimer"></videoCall-model>
    <notification ref="notification" @ok="videoCall" @hangup="incomingcall"></notification>
    <minimize ref="minimize" v-show="minimize"></minimize>
    <foot-comp></foot-comp>
  </div>
</template>
<script>
import footComp from "./components/footer";
import videoCallModel from "@/components/videoCallModel";
import notification from "@/components/videoCallModel/notification";
import minimize from "@/components/videoCallModel/minimize";
import { getAction } from "@/api/manage";

export default {
  components: {
    footComp,
    videoCallModel,
    notification,
    minimize,
  },
  data() {
    return {
      isShow: true,
      minimize: false,
      toTimerData: {},
    };
  },
  // 提供可注入子组件属性
  provide() {
    return {
      reload: this.reload,
      videoCall: this.videoCall,
      incomingcall: this.incomingcall,
    };
  },
  computed: {
    userId() {
      return this.$store.state.userInfo.id;
    },
  },
  watch: {
    userId(val) {
      this.initWebSocket(val);
    },
  },
  mounted() {
    var _this = this;
    if (
      this.$route.path.indexOf("login") == -1 &&
      this.$route.path.indexOf("register") == -1
    ) {
      // 用户信息
      this.$fetch(`/user/api/customer`).then((res) => {
        if (res.code == 0) {
          _this.$store.state.userName = res.data.nickname;
          _this.$store.state.userPhone = res.data.username;
          _this.$store.state.userAvatar = res.data.avatar;
          _this.$store.state.hasPwd = res.data.hasPwd;
          _this.$store.state.userInfo = res.data;
          _this.getPermission(res.data);
          // _this.initWebSocket();
        } else {
          // this.$message(res.message);
        }
      });
    }
  },
  destroyed: function () {
    // 离开页面生命周期函数
    this.websocketclose();
  },
  methods: {
    // 获取菜单显示权限
    async getPermission(userInfo) {
      const { data } = await getAction("/order/api/order/setting_info");
      console.log(data);
      if (
        !data.data.orderProfitAndLossVisiable ||
        data.data.orderProfitAndLossVisiable.includes(userInfo.id)
      ) {
        this.$store.state.userList.splice(7, 0, {
          name: "订单盈亏",
          isSelected: false,
        });
      }
    },
    openVideo() {
      this.minimize = false;
      this.$refs.videoCallModel.boxSelectShow = true;
    },
    toTimer(data) {
      this.$refs.minimize.timerData = data;
      this.toTimerData = data;
      // console.log(data)
    },
    // 视频通话
    videoCall(data) {
      console.log(data);
      this.$message.closeAll();
      if (data.id == this.$store.state.userInfo.id)
        return this.$message.error("错了哦，这是一条错误消息");
      this.$refs.videoCallModel.startVideo(data);
    },
    // 来电
    incomingcall(data) {
      console.log(data);
      // 接收方来电显示
      if (data.businessType == "videoCall") {
        this.$refs.notification.init(data);
      }
      // 发起方挂断
      if (data.businessType == "videoCallCancel") {
        this.$refs.notification.close();
        this.$refs.videoCallModel.close();
      }
      // 接收方挂断
      if (data.businessType == "videoCallHangup") {
        this.$refs.videoCallModel.close();
        this.$refs.notification.close();
      }
    },
    reload() {
      // 先隐藏
      this.isShow = false;
      // $nextTick() 将回调延迟到下次 DOM 更新循环之后执行
      this.$nextTick(() => {
        this.isShow = true;
      });
    },
    initWebSocket: function () {
      // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https
      // var userId = 1;
      var userId = this.$store.state.userInfo.id;
      var url = process.env.VUE_APP_WEBSOCKET_API + userId;
      this.websock = new WebSocket(url);
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen: function () {
      console.log("WebSocket连接成功");
    },
    websocketonerror: function () {
      console.log("WebSocket连接发生错误");
    },
    websocketonmessage: function (e) {
      let _this = this;
      var data = eval(`"${e.data}"`);
      console.log(e.type);
      console.log(e);
      console.log(data.indexOf("EXCEPTION_MESSAGE"));

      //处理订阅信息     EXCEPTION_MESSAGE
      if (data.indexOf("EXCEPTION_MESSAGE") == "-1") {
        //TODO 系统通知
        _this.$store.state.badge = false;
      } else if (data.indexOf("EXCEPTION_MESSAGE") != "-1") {
        //TODO 用户消息
        _this.$store.state.abnormal = false;
      }
    },
    websocketclose: function (e) {
      let _this = this;
      console.log("close");
      console.log(e);
      // console.log("connection closed (" + e.code + ")");
      _this.$store.state.badge = true;
      _this.$store.state.abnormal = true;
      this.reconnect();
    },
    reconnect() {
      var that = this;
      if (that.lockReconnect) return;
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      setTimeout(function () {
        console.info("尝试重连...");
        that.initWebSocket();
        that.lockReconnect = false;
      }, 5000);
    },
  },
};
</script>

<style lang="scss">
#orderlist {
  &.remark_modal {
    .dialog-footer {
      & > .el-button {
        padding: 10px 17px !important;
        height: auto;
        width: auto;
        font-size: 12px;
        span {
          line-height: 12px;
          height: 12px;
          display: inline-block;
        }
      }
      & > .el-button:first-child {
        color: #5e6066 !important;
      }
    }
  }
}
.el-form-item__error {
  padding-top: 2px !important;
}
.default-input {
  .icon {
    display: none;
  }
}
.el-icon-circle-close {
  color: #fff;
}
.el-date-range-picker {
  z-index: 10 !important;
}
.el-image-viewer__canvas {
  img {
    width: auto !important;
    height: auto !important;
  }
}
.title-mode {
  display: flex;
  align-items: center;
}
.ant-modal-mask,
.ant-modal-wrap {
  z-index: 2055 !important;
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #f5f7fa !important;
  color: #3455d3 !important;
}
.el-divider--vertical {
  width: 1px !important;
}
.app {
  position: relative;
  min-width: 1200px;
  .header {
    height: 90px;
  }
}
.el-message-box__status {
  top: 53% !important;
}
.el-scrollbar__bar.is-vertical {
  opacity: 1;
}
img {
  object-fit: cover !important;
}
* {
  word-break: break-all !important;
}
.el-button--default {
  color: #bec0c6;
  border-color: #bec0c6;
}
.add-remark {
  border-top: 1px dashed #dcdfe6;
  background: #fff;
  position: relative;
  min-height: 36px;
  display: flex;
  align-items: center;
  .edit-icon {
    width: 14px;
    height: 14px;
    background: url("~@/assets/img/icon_bainji_nor.png") no-repeat;
    background-size: cover;
    position: absolute;
    right: 30px;
    top: 50%;
    margin-top: -7px;
    cursor: pointer;
  }
  &:hover {
    textarea,
    .el-textarea::after {
      color: #3455d3;
    }
    .edit-icon {
      background: url("~@/assets/img/icon_bainji_hov.png") no-repeat;
      background-size: cover;
    }
  }
  .el-textarea {
    width: 823px;
    position: relative;

    &::after {
      content: "备注：";
      position: absolute;
      color: #5e6066;
      top: 5px;
      left: 15px;
    }
  }
  textarea {
    resize: none;
    border: 0;
    background: transparent;
    display: -webkit-box;
    text-align: justify;
    color: #5e6066;
    text-indent: 40px;
  }
  .add-title {
    width: 70px;
    display: flex;
    margin: 0 auto;
    font-size: 12px;
    justify-content: space-between;
    cursor: pointer;
    .add-icon {
      width: 16px;
      height: 16px;
      background: url("~@/assets/img/icon_add_nor.png") no-repeat;
      background-size: cover;
    }
    &:hover {
      color: #3455d3;
      .add-icon {
        background: url("~@/assets/img/icon_add_hov.png") no-repeat;
        background-size: cover;
      }
    }
  }
  .order_search {
    // width: 124px;
    // height: 30px;
    background: #3455d3;
    border-color: #3455d3;
    border-radius: 2px;
    font-size: 14px;
    line-height: 5px;
    color: #fff;
    &:hover {
      background: #2c4abb;
      border-color: #2c4abb;
    }
  }
}
</style>
